module.exports = __webpack_public_path__ + "img/getup_des_4.dfec7936.jpg";